export default __webpack_public_path__ + "static/Enduro_Stew-9af334f222b3fa82e39f879b89916e54.png";